import { graphql } from "src/graphql/generated";

export const updateTenantNameMutation = graphql(/* GraphQL */ `
    mutation UpdateTenantName($clientId: String!, $tenantId: String!, $name: String!) {
        updateTenantName(clientId: $clientId, tenantId: $tenantId, name: $name) {
            id
        }
    }
`);

export const attachTenantLogoMutation = graphql(/* GraphQL */ `
    mutation AttachTenantLogo($clientId: String!, $tenantId: String!, $imageId: String!) {
        attachTenantLogo(clientId: $clientId, tenantId: $tenantId, imageId: $imageId) {
            id
        }
    }
`);

export const updateTenantSEOMutation = graphql(/* GraphQL */ `
    mutation UpdateTenantSEO($clientId: String!, $tenantId: String!, $seo: TenantSEOConfigInput!) {
        updateTenantSEO(clientId: $clientId, tenantId: $tenantId, seo: $seo) {
            id
        }
    }
`);
